import React from "react";
import { WorkspaceKpi, WorkspaceKpis } from "./WorkspaceBand.jsx";

function formatMoney(value, currency = "CAD") {
  if (value == null) return "—";
  const amount = Number.isFinite(Number(value)) ? Number(value) : 0;
  return new Intl.NumberFormat("fr-CA", { style: "currency", currency: currency || "CAD" }).format(amount);
}

// Cellule du bandeau commun avec la Consolidation : carré d'état, valeur en couleur seulement pour une alerte.
export function KpiCard({ active = false, disabled = false, icon, label, onClick, primary, primaryTone = "neutral", secondary, tone }) {
  const valueClassName = primaryTone === "danger" ? "text-[#c5524a]" : primaryTone === "warning" ? "text-[#a86a24]" : "text-slate-900";
  return <WorkspaceKpi compact tone={tone} icon={icon} label={label} value={primary} sub={secondary} active={active} disabled={disabled} onClick={onClick} valueClassName={valueClassName} />;
}

export default function BillableKpiStrip({
  busy = false,
  currencyCode = "CAD",
  filters = {},
  kpis,
  onSelect,
}) {
  const overdueActive = Boolean(filters.overdueOnly);
  const status = filters.status || "";

  return (
    <WorkspaceKpis label="Indicateurs à facturer" className="max-sm:!grid-cols-1">
      <KpiCard
        active={!overdueActive && status === "eligible"}
        disabled={busy}
        label="Prêtes à facturer" tone="done"
        onClick={() => onSelect?.({ status: "eligible", overdueOnly: false })}
        primary={formatMoney(kpis.readyAmount, currencyCode)}
      />
      <KpiCard
        active={!overdueActive && status === "blocked"}
        disabled={busy}
        label="Bloquées" tone="blocked"
        onClick={() => onSelect?.({ status: "blocked", overdueOnly: false })}
        primary={formatMoney(kpis.blockedAmount, currencyCode)}
        primaryTone="warning"
      />
      <KpiCard
        active={overdueActive}
        disabled={busy}
        label="En retard (7 j+)" tone="progress"
        onClick={() => onSelect?.({ status: "", overdueOnly: true })}
        primary={kpis.overdueCount ? "À traiter" : "Aucun retard"}
        primaryTone="warning"
      />
      <KpiCard
        active={!overdueActive && status === ""}
        disabled={busy}
        label="Entreprises à traiter"
        onClick={() => onSelect?.({ status: "", overdueOnly: false })}
        primary={String(kpis.accountCount)}
        secondary={`${kpis.blockedAccountCount} avec des blocages`}
      />
    </WorkspaceKpis>
  );
}
